import React from "react";
import { motion } from "framer-motion";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { FaGithub, FaTelegram, FaVk, FaDiscord, FaLinkedin } from "react-icons/fa";
import { FiInstagram, FiSend } from "react-icons/fi";
import { BsFillPersonLinesFill } from "react-icons/bs";
import CV from "../../assets/resume-Vasilev-Daniil.pdf";
import { bannerImg } from "../../assets/index";

const Left = () => {
  const [text] = useTypewriter({
    words: [
      "Full-Stack Developer",
      "React/Node.js Specialist",
      "Web Performance Optimizer",
      "Cloud Solutions Architect"
    ],
    loop: true,
    typeSpeed: 40,
    deleteSpeed: 30,
    delaySpeed: 2500,
  });

  const socialLinks = [
    { icon: <FaGithub />, url: "https://github.com/ayakashimoto", label: "GitHub" },
    { icon: <FaLinkedin />, url: "https://linkedin.com/in/ayakashimoto", label: "LinkedIn" },
    { icon: <FaTelegram />, url: "https://t.me/ayakashimoto", label: "Telegram" },
    { icon: <FaVk />, url: "https://vk.com/ayakashimoto", label: "VK" },
    { icon: <FiInstagram />, url: "https://instagram.com/ayakashimoto", label: "Instagram" },
  ];

  const copyDiscord = () => {
    navigator.clipboard.writeText('ayakashimoto');
    alert('Discord username copied: ayakashimoto');
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
      className="w-full lg:w-5/12 h-full bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl shadow-2xl z-10 overflow-hidden border border-gray-700"
    >
      <div className="w-full h-3/5 relative group">
        <img
          className="w-full h-full object-cover transition-all duration-500 group-hover:scale-105"
          src={bannerImg}
          loading="eager"
          alt="Даниил Васильев"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
          <motion.p
            initial={{ y: 20 }}
            animate={{ y: 0 }}
            className="text-white text-lg font-medium"
          >
           Full-Stack Developer
          </motion.p>
        </div>
      </div>

      <div className="w-full h-2/5 flex flex-col justify-between">
        <div className="flex flex-col items-center gap-2 py-8 px-4">
          <motion.h1
            initial={{ y: 10 }}
            animate={{ y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent"
          >
            Даниил Васильев
          </motion.h1>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="text-lg text-gray-300 h-8 flex items-center"
          >
            {text}
            <Cursor cursorStyle="|" cursorBlinking={true} />
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
            className="flex justify-center gap-5 mt-4"
          >
            {socialLinks.map((link, index) => (
              <motion.a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ y: -3, scale: 1.1 }}
                className="text-xl text-gray-400 hover:text-white transition-colors duration-300"
                aria-label={link.label}
              >
                {link.icon}
              </motion.a>
            ))}
            <motion.button
              whileHover={{ y: -3, scale: 1.1 }}
              onClick={copyDiscord}
              className="text-xl text-gray-400 hover:text-white transition-colors duration-300"
              aria-label="Discord"
              title="Discord: ayakashimoto"
            >
              <FaDiscord />
            </motion.button>
          </motion.div>
        </div>

        <div className="flex h-16 border-t border-gray-700 divide-x divide-gray-700">
          <motion.a
            whileHover={{ backgroundColor: 'rgba(59, 130, 246, 0.1)' }}
            href={CV}
            target="_blank"
            rel="noopener noreferrer"
            className="w-1/2 flex justify-center items-center gap-2 text-sm uppercase tracking-wider text-gray-300 hover:text-blue-400 transition-colors duration-300"
          >
            <BsFillPersonLinesFill className="text-blue-400" />
            Резюме (PDF)
          </motion.a>

          <motion.button
            whileHover={{ backgroundColor: 'rgba(168, 85, 247, 0.1)' }}
            onClick={() => window.dispatchEvent(new Event('scrollToContact'))}
            className="w-1/2 flex justify-center items-center gap-2 text-sm uppercase tracking-wider text-gray-300 hover:text-purple-400 transition-colors duration-300"
          >
            <FiSend className="text-purple-400" />
            Контакты
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
};

export default Left;